import axios from 'axios'

export const LOGIN = ({ email, password }) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/api/users/login`, {
    email,
    password
  })
